import axios from './base'

export const getUserSession = () =>
  axios.get('/api/account/me').then(response => response.data)
